import { DatasetsUsersResponse } from "admin/types/interfaces/adminDatasetUsers";
import { useFetcher } from "~/hooks/useFetcher";

const { VITE_CATALOG_API } = import.meta.env;

/**
 * Fetches the users and groups with access to a dataset from the admin endpoint.
 * Passing a null datasetId gives SWR a null key, so no request is made until a
 * dataset is selected (i.e. the View Users dialog is opened).
 */
const useAdminDatasetUsers = (datasetId: string | null) => {
  const url = datasetId ? `${VITE_CATALOG_API}/admin/datasets/${datasetId}/users` : null;

  const { data, error, isLoading } = useFetcher<DatasetsUsersResponse>(url);

  return {
    users: data?.users ?? [],
    groups: data?.groups ?? [],
    isLoading,
    error,
  };
};

export default useAdminDatasetUsers;
